(ns client-portal.client.cohorts.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [shared.core.components.auth0.data :as auth0.d]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:cohorts])
(def franchise-groups-path (conj root-path :franchise-groups))
(def franchise-groups-by-concept-id-path (conj franchise-groups-path :by-concept-id))
(def franchise-groups-data-path (conj root-path :data))

(re/reg-auth0-loader
  :cohorts/load-franchise-groups-data
  (fn [[concept-id]]
    (conj franchise-groups-by-concept-id-path concept-id))
  (fn [_ concept-id]
    (when concept-id
      {:method :get
       :url "/api/cohorts/franchise-groups"
       :query-params {:concept-id concept-id}}))
  :transf (fn [resp]
            (or (some-> resp :body (util/->kebab-case-keywords))
                ""))
  :error-transf (fn [] []))

(re/reg-sub :cohorts/franchise-groups-data-
            (fn [db]
              (let [concept-id (concepts.d/current-concept-id db)
                    v (when concept-id (get-in db (conj franchise-groups-by-concept-id-path concept-id)))]
                (if (nil? v)
                  (re/dispatch-load [:cohorts/load-franchise-groups-data concept-id])
                  v))))

(re/reg-sub
  :cohorts/franchise-groups-data-keyed-
  :<- [:cohorts/franchise-groups-data-]
  (fn [franchise-groups-data]
    (some->> (util/when-not-loading franchise-groups-data)
             (map (fn [{:keys [id] :as fg}]
                    [id fg]))
             (into {}))))
